import React, { Component, ReactElement } from 'react';
import { GdkNavigation } from '@gdk/navigation';
import { LoggedInUser, UserRole } from '../../models/LoggedInUser';
import { Link, Route, withRouter } from 'react-router-dom';
import Button, { ButtonStyles } from './Button';
import DeleteCmtData from '../deleteCmtData/DeleteCmtData';
import TelematicsPolicyManagment from '../telematicsPolicyManagment/TelematicsPolicyManagment';
import { InvoluntaryTelematics } from '../involuntaryTelematics/InvoluntaryTelematics';
import BatchJobSettings from '../batchJobSettings/BatchJobSettings';
import TelematicsJobs from '../jobs/Jobs';
import { RouteComponentProps } from 'react-router-dom';
import { StaticContext } from 'react-router';
import { setCustomerDashboardPanel } from '../../helpers/navigationHelpers';

export interface LoginInfo {
    loggedInUser: LoggedInUser;
    onLoginLogout(isAuthenticated: boolean): void;
}

export class PrimaryNavigation extends Component<RouteComponentProps<any, StaticContext, any> & LoginInfo> {

    state = {
        navigation: GdkNavigation
    }

    componentDidMount(): void {
        window.scrollTo(0, 0);
        const config = {
            generateMobileNavHtml: true,
        };
        var navigation = new GdkNavigation({
            content: "#primary-navigation",
        }) 
        this.setState({
            navigation: navigation
        })
    }

    renderLogo(): ReactElement {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="114" height="33" viewBox="0 0 114 33" fill="none">
                <g clipPath="url(#clip0_544_11333)">
                    <path d="M0 6.93623C0 1.32266 3.14737 -0.0020752 8.43893 -0.0020752H17.2747C23.9387 -0.0020752 24.8647 2.41005 24.8647 6.14139V6.74856H19.0992C19.0992 4.83873 18.0133 4.60138 16.1392 4.60138H9.7618C6.80183 4.60138 6.03016 5.31894 6.03016 8.6032V10.9877C6.03016 14.272 6.79632 14.9895 9.7618 14.9895H16.029C17.5613 14.9895 19.0992 14.7522 19.0992 12.8975V12.3401H11.8013V8.36585H24.975V13.8249C24.975 19.3336 22.1198 19.5985 15.5053 19.5985H8.44444C3.15288 19.5985 0.00551202 18.2738 0.00551202 12.6602V6.93623H0Z" fill="#004B9B"/>
                    <path d="M26.4246 0.207642H47.3758V4.66209H32.2949V7.73106H46.5822V11.7053H32.2949V14.7797H47.7175V19.3887H26.4246V0.207642Z" fill="#004B9B"/>
                    <path d="M55.3683 0.207642H49.4978V19.3832H55.3683V0.207642Z" fill="#004B9B"/>
                    <path d="M57.1433 6.93623C57.1433 1.32266 60.2906 -0.0020752 65.582 -0.0020752H72.4886C80.8449 -0.0020752 81.9307 1.79736 81.8813 7.22877H76.0108V6.69889C76.0108 5.31894 75.0077 4.92153 73.2604 4.92153H66.8609C63.7688 4.92153 63.1843 6.37874 63.1843 8.76329V10.8277C63.1843 13.6096 63.7688 14.6694 66.5468 14.6694H72.8138C75.4596 14.6694 76.2533 14.4045 76.2533 12.0199H82.1238V13.8193C82.1238 17.0484 80.9606 19.593 75.0628 19.593H65.5931C60.3017 19.593 57.1544 18.2683 57.1544 12.6547V6.93071L57.1433 6.93623Z" fill="#004B9B"/>
                    <path d="M83.1433 6.93623C83.1433 1.32266 86.2906 -0.0020752 91.5823 -0.0020752H100.997C106.288 -0.0020752 109.436 1.32266 109.436 6.93623V12.6602C109.436 18.2738 106.288 19.5985 100.997 19.5985H91.5823C86.2906 19.5985 83.1433 18.2738 83.1433 12.6602V6.93623ZM89.1735 10.8277C89.1735 13.6096 89.7577 14.6694 92.5303 14.6694H100.043C102.821 14.6694 103.406 13.6096 103.406 10.8277V8.76329C103.406 6.37874 102.821 4.92154 99.7291 4.92154H92.8501C89.7577 4.92154 89.1735 6.37874 89.1735 8.76329V10.8277Z" fill="#004B9B"/>
                    <path d="M109.992 17.6832C109.992 16.64 110.841 15.7899 111.894 15.7899C112.947 15.7899 113.785 16.64 113.785 17.6832C113.785 18.7264 112.941 19.5875 111.894 19.5875C110.847 19.5875 109.992 18.7375 109.992 17.6832ZM113.553 17.6832C113.553 16.7614 112.809 16.0162 111.889 16.0162C110.968 16.0162 110.218 16.7614 110.218 17.6832C110.218 18.605 110.963 19.3557 111.889 19.3557C112.815 19.3557 113.553 18.6105 113.553 17.6832ZM112.837 18.7485H112.528L111.922 17.7715H111.448V18.7485H111.189V16.6289H112.115C112.291 16.6289 112.473 16.64 112.633 16.7338C112.793 16.8221 112.87 17.0098 112.87 17.1919C112.87 17.6114 112.577 17.766 112.203 17.7715L112.842 18.7485H112.837ZM111.844 17.5673C112.142 17.5673 112.605 17.6169 112.605 17.1864C112.605 16.8607 112.319 16.8166 112.054 16.8166H111.448V17.5673H111.844Z" fill="#004B9B"/>
                    <path d="M0.988281 30.3777V23.9517H3.14254C4.91178 23.9517 6.46104 24.9707 6.46104 27.1647C6.46104 29.3495 4.91178 30.3777 3.14254 30.3777H0.988281ZM2.36334 29.1843H3.00504C4.05924 29.1843 5.06762 28.6794 5.06762 27.1647C5.06762 25.65 4.05924 25.1359 3.00504 25.1359H2.36334V29.1843ZM9.4434 26.8159C8.81089 26.8159 8.52669 27.3391 8.52669 28.1286V30.3777H7.25248V25.751H8.52669V26.5221C8.7742 25.9438 9.12255 25.751 9.69091 25.751H10.2043V26.8159H9.4434ZM10.8334 30.3777V25.751H12.1076V30.3777H10.8334ZM10.7967 25.09V23.7406H12.1534V25.09H10.7967ZM14.3804 30.3777L12.6936 25.751H13.9954L14.9671 28.7437L15.9296 25.751H17.2405L15.5446 30.3777H14.3804ZM17.3983 28.0552C17.3983 26.8801 18.1133 25.6776 19.6809 25.6776C21.3126 25.6776 21.9635 26.8801 21.9635 27.9358C21.9635 28.1103 21.9543 28.2479 21.9452 28.3489H18.6267C18.7184 29.0007 19.1309 29.4046 19.7726 29.4046C20.2859 29.4046 20.6251 29.2026 20.7259 28.8079H21.9727C21.7893 29.8085 20.9093 30.4511 19.7726 30.4511C18.205 30.4511 17.3983 29.221 17.3983 28.0552ZM18.645 27.5411H20.6893C20.6526 27.027 20.2951 26.6139 19.6809 26.6139C19.1034 26.6139 18.755 26.8985 18.645 27.5411ZM22.787 30.3777V23.9517H27.2055V25.1359H24.162V26.4946H26.9763V27.688H24.162V29.1843H27.2513V30.3777H22.787ZM29.4133 30.4511C28.5241 30.4511 27.9007 29.8544 27.9007 29.0649C27.9007 28.1653 28.5791 27.6054 29.5967 27.6054H30.3667C30.5959 27.6054 30.715 27.4585 30.715 27.2657C30.715 26.8801 30.4217 26.6139 29.8992 26.6139C29.34 26.6139 29.0466 26.9628 29.0375 27.3483H27.9007C27.9466 26.4211 28.6983 25.6776 29.9633 25.6776C31.1367 25.6776 31.9893 26.3569 31.9893 27.4034V30.3777H30.715V29.7351C30.5592 30.1665 30.0459 30.4511 29.4133 30.4511ZM29.1292 29.0099C29.1292 29.322 29.3767 29.5239 29.7433 29.5239C30.3575 29.5239 30.715 29.0649 30.715 28.4774V28.4224H29.7892C29.395 28.4224 29.1292 28.6519 29.1292 29.0099ZM34.6403 30.4511C33.5129 30.4511 32.752 29.8177 32.697 28.8171H33.7972C33.852 29.2302 34.1728 29.4872 34.6403 29.4872C35.0438 29.4872 35.3095 29.2944 35.3095 29.0374C35.3095 28.0919 32.8253 29.019 32.8253 27.0729C32.8253 26.2559 33.5404 25.6776 34.4846 25.6776C35.594 25.6776 36.3456 26.2743 36.3822 27.1831H35.2822C35.2271 26.7883 34.8605 26.5772 34.5212 26.5772C34.1547 26.5772 33.9162 26.7333 33.9162 27.027C33.9162 27.9726 36.437 26.8985 36.437 28.9915C36.437 29.8728 35.7312 30.4511 34.6403 30.4511ZM37.0897 32.2504V31.2498H37.6033C37.8508 31.2498 38.0155 31.1488 38.1349 30.7999L38.3091 30.3226L36.6499 25.751H37.9516L38.9232 28.7437L39.8859 25.751H41.1968L39.5191 30.3318L39.3082 30.9468C39.0059 31.8097 38.7032 32.2504 37.7589 32.2504H37.0897ZM43.6099 30.3777V23.9517H46.2407C47.6157 23.9517 48.4134 24.7963 48.4134 25.9805C48.4134 27.1555 47.6157 28.0093 46.2407 28.0093H44.9941V30.3777H43.6099ZM44.9941 26.8618H46.1674C46.7999 26.8618 47.075 26.4487 47.075 25.9805C47.075 25.5123 46.7999 25.0992 46.1674 25.0992H44.9941V26.8618ZM51.2234 26.8159C50.5908 26.8159 50.3067 27.3391 50.3067 28.1286V30.3777H49.0325V25.751H50.3067V26.5221C50.5542 25.9438 50.9026 25.751 51.4709 25.751H51.9844V26.8159H51.2234ZM54.6252 30.4511C53.2041 30.4511 52.1865 29.4413 52.1865 28.0644C52.1865 26.6874 53.2041 25.6776 54.6252 25.6776C56.046 25.6776 57.0636 26.6874 57.0636 28.0644C57.0636 29.4413 56.046 30.4511 54.6252 30.4511ZM53.4701 28.0644C53.4701 28.8263 53.9375 29.3495 54.6252 29.3495C55.3126 29.3495 55.78 28.8263 55.78 28.0644C55.78 27.2932 55.3126 26.77 54.6252 26.77C53.9375 26.77 53.4701 27.2932 53.4701 28.0644Z" fill="#004B9B"/>
                </g>
                <defs>
                    <clipPath id="clip0_544_11333">
                        <rect width="114" height="32.3284" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        )
    }

    render(): ReactElement {
        const { loggedInUser } = this.props;
        const { navigation } = this.state;

        const displayAdminTools = (loggedInUser && (loggedInUser.userRole === UserRole.Admin || loggedInUser.userRole === UserRole.Agent || loggedInUser.userRole === UserRole.ServiceUser)) ? "block" : "none";

        return (
            <>
            <header id="primary-header" role="banner" className="primary-header">
                <div className="header-logo">
                    <a aria-label="GEICO Home" onClick={this.redirectToDashboard}>{this.renderLogo()}</a>
                </div>
                    {this.renderPolicyHeaderLinks()}
                <div className="header-links">
                    <ul>
                        {<li id="helpCenter">
                            <a data-side-panel-trigger="helpcenter" onClick={this.redirectToHelpCenter} aria-expanded="true">
                                <span aria-label="help center" className="icon-help-button"></span>
                                <span className="header-link"><u>Help Center</u></span>
                            </a>
                        </li>}
                        <li>
                            <a data-side-panel-trigger="menu" className="hamburger-menu" href="/">
                                <span ></span>
                                <span ></span>
                                <span ></span>
                                <span ></span>
                                <div className="header-link menu-header-link">Menu</div>
                            </a>
                        </li>
                    </ul>
                </div>
            </header>
            <nav id="primary-navigation" role="navigation">
                <div className="nav-background"></div>
               
                <div className="panel-wrapper" data-side-panel="menu">
                    <div className="nav-menu">
                        <ul className="nav-primary-tier nav-items nav-dark-mode-switch-wrapper">
                            {this.displayDashboardButton()}
                            {this.displayDashboardLink(navigation)}
                            {this.displayVehiclesLink(navigation)}
                            {this.displayDevicesLink(navigation)}
                            {this.displayHelpCenterLink()}
                            {this.displayPolicyOverviewLink()}
                            <li><a className="nav-menu-item" data-nav-items-trigger="admin-overview" href="/" aria-haspopup="menu" style={{display:displayAdminTools}}>Admin Tools</a></li>
                            <li className="nav-additional-links">
                                <div className="nav-bottom-links">
                                    <ul className="list">
                                        <li onClick={() => this.props.onLoginLogout(loggedInUser.isAuthenticated)}><a href="/">Log Out</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div className="nav-secondary-tier">
                            <div className="nav-back"><a href="/">Back</a></div>
                            <div className="nav-secondary-panel" data-nav-items="admin-overview">
                                <div className="nav-header">Admin Tools</div>
                                {this.policySearchMenu(navigation)}
                                {this.telematicsJobs(navigation)}
                                {this.involuntaryTelematics(navigation)}
                                {this.batchJobSettings(navigation)}
                                {this.deleteCmtData(navigation)}
                                {this.gustoFlagStatus(navigation)}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            </>
        );
    }

    redirectToHelpCenter = () => {
        const helpCenterWindow = window.open("https://www.geico.com/driveeasypro/help-center/", '_blank');
        if (helpCenterWindow) {
            helpCenterWindow.focus();
        }
    }

    redirectToDashboard = () => {
        setCustomerDashboardPanel("dashboard");
    }

    displayHelpCenterLink = () => {
        return (
            <li><a className="nav-menu-item dashboard-menu-item" data-nav-items-trigger="help-center" onClick={this.redirectToHelpCenter} aria-haspopup="menu">Help Center</a></li>
        );
    }

    displayDashboardLink = (nav: GdkNavigation | any) => {
        return (
            <li onClick={() => this.closeNavAndChangePanel(nav, "dashboard")} className="dashboard-menu-item">
                <Link to={"/dashboard"}>
                    <div className="nav-menu-item dashboard-menu-item" data-nav-items-trigger="dashboard-overview" aria-haspopup="menu">Dashboard</div>
                </Link>
            </li>
        );
    }

    displayVehiclesLink = (nav: GdkNavigation | any) => {
        return (
            <li onClick={() => this.closeNavAndChangePanel(nav, "vehicles")} className="dashboard-menu-item">
                <Link to={"/dashboard"}>
                    <div className="nav-menu-item dashboard-menu-item" data-nav-items-trigger="dashboard-overview" aria-haspopup="menu">Vehicles</div>
                </Link>
            </li>
        );
    }

    displayDevicesLink = (nav: GdkNavigation | any) => {
        return (
            <li onClick={() => this.closeNavAndChangePanel(nav, "devices")} className="dashboard-menu-item">
                <Link to={"/dashboard"}>
                    <div className="nav-menu-item dashboard-menu-item" data-nav-items-trigger="dashboard-overview" aria-haspopup="menu">Devices</div>
                </Link>
            </li>
        )
    }

    displayPolicyOverviewLink = () => {
        let url = "/dashboard";
        if (localStorage.getItem("returnUrl")) {
            let returnUrl = localStorage.getItem("returnUrl") || "";
            url = encodeURIComponent(returnUrl) || "/dashboard"
        }
        if (url == "/dashboard") {
            return (
                <li>
                    <Link to={url}>
                        <div className="nav-menu-item" data-nav-items-trigger="dashboard-overview" aria-haspopup="menu">Policy Overview</div>
                    </Link>
                </li>
            )
        }
        else {
            return (
                <li>
                    <a href={url}>
                        <div className="nav-menu-item" data-nav-items-trigger="dashboard-overview" aria-haspopup="menu">Policy Overview</div>
                    </a>
                </li>
            )
        }
    }

    displayDashboardButton = () => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && (loggedInUser.userRole === UserRole.Admin) && window.location.pathname != '/dashboard') ? "" : "none";

        return (
            <li onClick={() => setCustomerDashboardPanel("dashboard")} style={{display:display}}>
                <Link to="/dashboard">
                    <div className="nav-menu-item" data-nav-items-trigger="dashboard-overview" aria-haspopup="menu">Dashboard</div>
                </Link>
            </li>
        )
    }

    closeNavAndChangePanel = (nav: GdkNavigation | any, panel: string) => {
        setCustomerDashboardPanel(panel)
        nav.closeNavigation();
    }

    involuntaryTelematics = (nav: GdkNavigation | any) => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && loggedInUser.userRole === UserRole.Admin) ? "" : "none";
        return (
            <div onClick={() => nav.closeNavigation()}>
                <Link to="/InvoluntaryTelematics" style={{ display: display }}><div className="nav-header nav-header-link">(In)voluntary Telematics</div></Link>
            </div>
        );
    }

    batchJobSettings = (nav: GdkNavigation | any) => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && loggedInUser.userRole === UserRole.Admin) ? "" : "none";
        return (
            <div onClick={() => nav.closeNavigation()}>
                <Link to="/BatchJobSettings" style={{ display: display }}><div className="nav-header nav-header-link">Batch Job Settings</div></Link>
            </div>
        );
    }

    gustoFlagStatus = (nav: GdkNavigation | any) => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && loggedInUser.userRole === UserRole.Admin) ? "" : "none";
        return (
            <div onClick={() => nav.closeNavigation()}>
                <Link to="/GustoFlagStatus" style={{ display: display }}><div className="nav-header nav-header-link">Gusto Flag Status</div></Link>
            </div>
        );
    }

    deleteCmtData = (nav: GdkNavigation | any) => {
        const { loggedInUser } = this.props;
        const eligibleEnvironment = window.location.hostname.split("-")[1] || window.location.hostname === "localhost";
        const display = (loggedInUser && loggedInUser.userRole === UserRole.Admin) && eligibleEnvironment ? "" : "none";
        return (
            <div onClick={() => nav.closeNavigation()}>
                <Link to="/DeleteCmtData" style={{ display: display }}><div className="nav-header nav-header-link">Delete CMT Data</div></Link>
            </div>
        );
    }

    headerLeftLinks = () => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && (loggedInUser.userRole === UserRole.Admin || loggedInUser.userRole === UserRole.Agent || loggedInUser.userRole === UserRole.ServiceUser)) ? "" : "none";
        return (
            <div id="header-left-links" style={{ display: display }} >
                <ul className="desktop-links">
                    <li>
                        <a href="/" data-side-panel-trigger="Telematics" className="">
                            Telematics
                            <span className="icon-chevron-down" />
                            <span className="nav-separator" />
                        </a>
                    </li>
                </ul>
                <ul className="mobile-links">
                    <li><a href="/" data-side-panel-trigger="mobile-menu" className="hamburger-menu"> </a></li>
                </ul>
            </div>
        )
    }

    telematicsJobs = (nav: GdkNavigation | any) => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && (loggedInUser.userRole === UserRole.Admin)) ? "" : "none";
        return (
            <div onClick={() => nav.closeNavigation()}>
                <Link to="/Jobs" style={{ display: display }}><div className="nav-header nav-header-link">Telematics Jobs</div></Link>
            </div>
        );
    }

    policySearchMenu = (nav: GdkNavigation | any) => {
        const { loggedInUser } = this.props;
        const display = (loggedInUser && (loggedInUser.userRole === UserRole.Admin || loggedInUser.userRole === UserRole.Agent || loggedInUser.userRole === UserRole.ServiceUser)) ? "" : "none";
        return (
            <div onClick={() => nav.closeNavigation()}>
                <Link to="/" style={{ display: display }}><div className="nav-header nav-header-link">Policy Search</div></Link>
            </div>
        );
    }

    showUserHeader = () => {
        const { loggedInUser } = this.props;
        if (loggedInUser.isAuthenticated) {
            return (
                <li>
                    <a>
                        <span aria-label="Account" className="right-text-separator">
                            {loggedInUser?.account?.name + " (" + LoggedInUser.GetRoleName(loggedInUser) + ") "}
                        </span>
                    </a>
                </li>
            );
        }
    }

    renderPolicyHeaderLinks = () => {
        return(
            <div className="policy-header-links" id="policy-header-links">
                <Button id="header-dashboard" title="Dashboard" btnStyle={ButtonStyles.RightGreenButton} onClick={() => setCustomerDashboardPanel("dashboard")} />
                <Button id="header-vehicles" title="Vehicles" btnStyle={ButtonStyles.RightGreenButton} onClick={() => setCustomerDashboardPanel("vehicles")} />
                <Button id="header-devices" title="Devices" btnStyle={ButtonStyles.RightGreenButton} onClick={() => setCustomerDashboardPanel("devices")} />
            </div>
        );
    }

    enablePolicyManagement = () => {
        return (<Route exact path='/' render={() => (<TelematicsPolicyManagment />)} />);
    }

    enableInvoluntaryTelematics = () => {
        return (<Route exact path='/InvoluntaryTelematics' render={() => (<InvoluntaryTelematics />)} />);
    }

    enableBatchJobSettings = () => {
        return (<Route exact path='/BatchJobSettings' render={() => (<BatchJobSettings />)} />);
    }

    enableTelematicsJobsPanel = () => {
        return (<Route exact path='/Jobs' render={() => (<TelematicsJobs />)} />);
    }

    enableCmtDelete = () => {
        if (window.location.hostname.split("-")[1] || window.location.hostname === "localhost") {
            return (<Route exact path='/DeleteCmtData' render={() => (<DeleteCmtData />)} />);
        }
    }
}

export default withRouter(PrimaryNavigation);